<template>
  <a
    class="predictive-search-card"
    :href="`https:${$variable('store.localisedShopDomain')}products/${product.handle}`"
  >
    <responsive-image
      :image="product.images?.['1'] || product.images[0]"
      block-class="predictive-search-card"
      :alt="product.title"
    />

    <div class="predictive-search-card__content">
      <ais-highlight
        :hit="product"
        :attribute="attribute"
        highlighted-tag-name="b"
        :class-names="{
          'ais-Highlight': 'text-body-2xs predictive-search-card__title',
        }"
      />

      <p>
        <span
          v-if="formattedCompareAtPrice"
          class="
            text-body-2xs
            predictive-search-card__price
            predictive-search-card__price--compare-at-price
          "
          v-text="formattedCompareAtPrice"
        />
        <span
          class="text-body-2xs predictive-search-card__price"
          :class="{
            'predictive-search-card__price--sale': formattedCompareAtPrice
          }"
          v-text="formattedPrice"
        />
      </p>
    </div>
  </a>
</template>

<script>

/**
 * Vue: Predictive search card (predictive-search-bar)
 * -----------------------------------------------------------------------------
 * Displays products as listed cards in predictive search results.
 *
 * @param {Object} product - Product object, either trending product or from Boost.
 *
 */

import ResponsiveImage from '~global/images/responsive-image.vue'
import { AisHighlight } from 'vue-instantsearch/vue3/es'

export default {
  name: 'PredictiveSearchCard',

  components: {
    ResponsiveImage,
    AisHighlight,
  },

  props: {
    product: {
      type: Object,
      default: () => null,
    },
  },

  computed: {

    /**
     * Compute highlight attribute.
     * @returns {String}
     */
    attribute() {
      if (this.$variable('store.languagePrimary')) {
        return 'title'
      }

      const languageCode = this.$variable('store.language').toUpperCase()
      const attribute = `translations${languageCode}`
      const test = this.product[attribute].title

      return test
        ? `${attribute}.title`
        : 'title'
    },

    /**
     * Compute price template.
     * @returns {String}
     */
    formattedPrice() {
      if (!this.product.price.min) {
        return this.$string('accessibility.loading')
      }

      if (this.product.price.min <= 0) {
        return this.$string('product.prices.free')
      }

      return this.$formatMoney(this.product.price.min)
    },

    /**
     * Compute price template.
     * @returns {String | null}
     */
    formattedCompareAtPrice() {
      if (!this.product?.compareAtPrice?.amount) {
        return null
      }

      return this.$formatMoney(this.product.compareAtPrice.amount)
    },
  },
}
</script>

<style lang="scss">
  @import './predictive-search-card';
</style>
